module.exports = __webpack_public_path__ + "static/am_header-f1e42fdeebc39abe4258236ef9136135.png";